import React, { useEffect, useState } from 'react'
import CustomCard from "../../../components/Common/CustomCard";
import { getListOfApps, getPlanSpecificationDetails } from "../../../store/menu/home/actions";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import AppsList from "../common/AppsList";
import { useNavigate } from 'react-router-dom';
import CustomPopup from '../../../components/Common/CustomPopup';
import { setPayementInformation } from '../../../store/actions';
import { billingContent, enterpriseContent } from './helper/ContentPopup';
import { planIds } from '../../../config';
import { isNotNullOrUndefined } from '../../../common/functions';


const AddApp = ({ from }) => {
    //constants and state
    const dispatch = useDispatch();
    const AppListState = state => state.Home
    const AppListProperties = createSelector(
        AppListState,
        AppListDetails => ({
            appsList: AppListDetails?.appsListDetails?.appsList,
            responseMessage: AppListDetails?.appsListDetails?.responseMessage,
            responseStatus: AppListDetails?.appsListDetails?.responseStatus,
            loading: AppListDetails?.appsListDetails?.loading,
            appListCount: AppListDetails?.appsListDetails?.appListCount,
            appsMaxCount: AppListDetails?.appsListDetails?.appsMaxCount,
            appListFetched: AppListDetails?.appsListDetails?.responseCode,



        })
    )

    const { appsList, loading, appListCount, responseMessage, responseStatus, appsMaxCount, appListFetched } = useSelector(
        AppListProperties
    )
    const ConstDetailsProp = useSelector(state => state.Login.constDetails)
    const { card_setup, status } = ConstDetailsProp
    const navigate = useNavigate();
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const { plan: planDetails, loading: planApiLoading, active, trial_act } = useSelector(state => state.Home?.planSpecificationDetails?.plan)
    const { enterprise } = planIds
    const isPlanDetails = isNotNullOrUndefined(active) && isNotNullOrUndefined(trial_act)
    const PlanState = useSelector(state => state.Plan)
    const { planAdded } = PlanState




    //effects
    useEffect(() => {
        dispatch(getListOfApps({}))
        dispatch(getPlanSpecificationDetails({}))
        // if (!planDetails?.plan_id && !planApiLoading) {
        //     dispatch(getPlanSpecificationDetails({}))

        // }
    }, [])




    const handleClickAddCard = () => {
        dispatch(setPayementInformation({ from: "payment-information" }))
        navigate('/settings/billing-details')
    }
    const handleClickUpgrade = () => {
        navigate('/settings/pricing')

    }

    const handleClose = () => {
        setPopupDetails({ open: false })
    }
    const handleAddApp = () => {
        if (!card_setup) {
            setPopupDetails({
                open: true, titleText: `Add application`,
                bodyText: <div className="billing"><p>To add your first application, please setup your billing information.</p><span>Note: You will be charged once your trial plan ends.</span></div>,
                primaryButtonText: 'Add card', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleClickAddCard, handleClickSecondaryButton: handleClose, handleClose: handleClose
            })
        }
        else if (appListCount === appsMaxCount) {
            if (planDetails?.plan_id === enterprise) {
                setPopupDetails({
                    open: true, titleText: `Add app`,
                    bodyText: enterpriseContent,
                    primaryButtonText: 'Close', handleClickPrimaryButton: handleClose, handleClose: handleClose
                })
            }
            else {
                setPopupDetails({
                    open: true, titleText: `Upgrade to continue`,
                    bodyText: <div className="billing"><p>You’ve reached your app limit, please upgrade your plan to continue.</p></div>,
                    primaryButtonText: 'Upgrade', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleClickUpgrade, handleClickSecondaryButton: handleClose, handleClose: handleClose
                })
            }

        }
        else if ((isPlanDetails ? (!trial_act && !active) : (isNotNullOrUndefined(status) && status !== "active"))) {
            setPopupDetails({
                open: true, titleText: `Add app`,
                bodyText: <div className="billing">You have no active plan, please activate your plan to
                    continue.</div>,
                primaryButtonText: 'Activate', secondaryButtonText: 'Cancel', handleClickPrimaryButton: handleClickUpgrade, handleClickSecondaryButton: handleClose, handleClose: handleClose
            })
        }
        else {
            navigate('/application/add-application')
        }
    }

    let buttonDetails = [
        {
            'buttonText': 'Add app', buttonType: 'primary', callBackFunction: () => handleAddApp(),
            tooltipText: `You’ve used your app limit, please delete an app to add new one!`,
            tooltipId: 'Addapp',
        }
    ]
    return (
        <React.Fragment>
            <CustomCard
                titleText={`Application${appListCount > 1 ? "s" : ""} (${appListCount})`}
                buttonsList={buttonDetails}
            >
                <AppsList appsList={appsList} loading={loading} responseMessage={responseMessage} responseStatus={responseStatus} from={from} />
                {(appsList.length > 3 && from === "home") && <span className='all-apps' onClick={() => navigate('/application')}>View all applications</span>}
            </CustomCard>
            {popupDetails.open &&
                <CustomPopup
                    popupDetails={popupDetails}
                />
            }
        </React.Fragment>
    );
};

export default AddApp;